

































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import ImgPreview from "@/components/common/upload/ImgPreview.vue";
import ProfileImgUploader from "@/components/common/upload/ProfileImgUploader.vue";
import BannerImgUploader from "@/components/common/upload/BannerImgUploader.vue";
import { Channel } from "@/types/group/group";

@Component({
    computed: { ...mapGetters(["user"]) },
    components: { ImgPreview, ProfileImgUploader, BannerImgUploader },
    mixins: [validationMixin],
    validations: {
        form: {
            channelName: {
                required,
                maxLength: maxLength(50),
            },
            description: {
                required,
                maxLength: maxLength(2000),
            },
        },
    },
})
export default class ChannelEdit extends Vue {
    private form = {
        channelName: "",
        description: "",
        profileImgSrc: "",
    };

    private user!: any;
    private isPrivate: boolean = false;
    private communityId: number = parseInt(this.$route.params.community_id);
    private channelId: number = parseInt(this.$route.params.channel_id);
    private channelInfo: Channel = {} as Channel;
    private channelList: Channel[] = [];
    private isMoveChannel: boolean = false;

    async mounted() {

        // this.channelInfo = await this.$api.getChannelInfo(
        //     this.communityId,
        //     this.channelId
        // );
        // this.form.channelName = this.channelInfo.name;
        // this.form.description = this.channelInfo.description;
        // this.form.profileImgSrc = this.channelInfo.profile_img;
    }
    async editChannel() {
        // this.$v.form.$touch();
        // if (this.$v.form.$anyError) {
        //     return;
        // }
        // const result = await this.$api.editChannel(
        //     this.communityId,
        //     this.channelId,
        //     this.form.channelName,
        //     this.form.description,
        //     this.isPrivate,
        //     this.form.profileImgSrc
        // );
        //
        // //todo: 백엔드 연결 후 분기 처리
        // if (result) {
        //     this.$router.push(`/community/${this.communityId}/setting/channel`);
        // }
    }

    validateState(name) {
        const { $dirty, $error } = this.$v.form[name]!;
        return $dirty ? !$error : null;
    }

    getProfileImgSrc(imgSrc: string) {
        this.form.profileImgSrc = imgSrc;
    }
    openDeleteChannelModal() {
        this.isMoveChannel = false;
        (this.$refs.deleteChannelModal as any).show();
    }
    async deleteChannel() {
        // let result = await this.$api.deleteChannel(
        //     this.communityId,
        //     this.channelId
        // );
        // //todo: 백엔드 연결 후 분기 처리
        // console.log(result);
        // (this.$refs.deleteChannelModal as any).hide();
        // (this.$refs.deleteDone as any).show();
    }
    async moveChannelPosting() {
        // this.isMoveChannel = true;
        // this.channelList = await this.$api.getChannelList(
        //     this.communityId,
        //     this.channelId
        // );
    }
    async combinedChannel(combined_channel_id: number) {
        // const result = await this.$api.combinedChannel(
        //     this.communityId,
        //     this.channelId,
        //     combined_channel_id
        // );
        // //todo: 분기처리
        // if (result) {
        //     (this.$refs.combindDone as any).show();
        //     (this.$refs.deleteChannelModal as any).hide();
        // } else {
        // }
    }
}
